// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monacoContainer_V75Gq {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  overflow: hidden;
}

/* .monacoContainer :global(.monaco-editor) {
  border: none !important;
  border-radius: 0 !important;
}

.monacoContainer :global(.monaco-editor .overflow-guard) {
  border-radius: 0 !important;
}

.monacoContainer :global(.monaco-editor .margin) {
  background-color: #252526 !important;
}

.monacoContainer :global(.monaco-editor .monaco-editor-background) {
  background-color: #1e1e1e !important;
}

.monacoContainer :global(.monaco-editor .line-numbers) {
  color: #858585 !important;
}

.monacoContainer :global(.monaco-editor .current-line) {
  background-color: #2a2d2e !important;
  border: none !important;
}

.monacoContainer :global(.monaco-editor .selection) {
  background-color: #264f78 !important;
}

.monacoContainer :global(.monaco-editor .inactive-selection) {
  background-color: #3a3d41 !important;
}

.monacoContainer :global(.monaco-editor .cursor) {
  background-color: #aeafad !important;
}

.monacoContainer :global(.monaco-editor .whitespace) {
  color: #3b3b3b !important;
}

.monacoContainer :global(.monaco-editor .indent-guide) {
  background-color: #404040 !important;
}

.monacoContainer :global(.monaco-editor .indent-guide.active) {
  background-color: #707070 !important;
}

.monacoContainer :global(.monaco-editor .scrollbar) {
  background-color: #2d2d30 !important;
}

.monacoContainer :global(.monaco-editor .scrollbar .slider) {
  background-color: #424242 !important;
}

.monacoContainer :global(.monaco-editor .scrollbar .slider:hover) {
  background-color: #4f4f4f !important;
}

.monacoContainer :global(.monaco-editor .scrollbar .slider.active) {
  background-color: #5a5a5a !important;
}


.monacoContainer :global(.monaco-editor .token.keyword) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.string) {
  color: #ce9178 !important;
}

.monacoContainer :global(.monaco-editor .token.comment) {
  color: #6a9955 !important;
}

.monacoContainer :global(.monaco-editor .token.number) {
  color: #b5cea8 !important;
}

.monacoContainer :global(.monaco-editor .token.regexp) {
  color: #d16969 !important;
}

.monacoContainer :global(.monaco-editor .token.type) {
  color: #4ec9b0 !important;
}

.monacoContainer :global(.monaco-editor .token.class) {
  color: #4ec9b0 !important;
}

.monacoContainer :global(.monaco-editor .token.interface) {
  color: #4ec9b0 !important;
}

.monacoContainer :global(.monaco-editor .token.enum) {
  color: #4ec9b0 !important;
}

.monacoContainer :global(.monaco-editor .token.function) {
  color: #dcdcaa !important;
}

.monacoContainer :global(.monaco-editor .token.variable) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.constant) {
  color: #4fc1ff !important;
}

.monacoContainer :global(.monaco-editor .token.parameter) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.property) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.operator) {
  color: #d4d4d4 !important;
}

.monacoContainer :global(.monaco-editor .token.delimiter) {
  color: #d4d4d4 !important;
}

.monacoContainer :global(.monaco-editor .token.tag) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.attribute.name) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.attribute.value) {
  color: #ce9178 !important;
}

.monacoContainer :global(.monaco-editor .token.meta) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.meta.tag) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag) {
  color: #808080 !important;
}

.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag.begin) {
  color: #808080 !important;
}

.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag.end) {
  color: #808080 !important;
}

.monacoContainer :global(.monaco-editor .token.entity.name.tag) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.entity.other.attribute-name) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.support.type.property-name) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.variable.language) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.variable.other) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.variable.other.property) {
  color: #9cdcfe !important;
}

.monacoContainer :global(.monaco-editor .token.constant.language) {
  color: #569cd6 !important;
}

.monacoContainer :global(.monaco-editor .token.constant.numeric) {
  color: #b5cea8 !important;
}

.monacoContainer :global(.monaco-editor .token.constant.character) {
  color: #ce9178 !important;
}

.monacoContainer :global(.monaco-editor .token.constant.other) {
  color: #4fc1ff !important;
}

.monacoContainer :global(.monaco-editor .token.invalid) {
  color: #f44747 !important;
}

.monacoContainer :global(.monaco-editor .token.invalid.deprecated) {
  color: #f44747 !important;
}

.monacoContainer :global(.monaco-editor .token.invalid.illegal) {
  color: #f44747 !important;
}

.monacoContainer :global(.monaco-editor .token.invalid.unexpected) {
  color: #f44747 !important;
} */

/* Estilos para el resaltado JSX/TSX */
.monacoContainer_V75Gq .JSXElement.JSXText.tastyPizza {
  color: #d4d4d4 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXIdentifier {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXAttribute {
  color: #9cdcfe !important;
}

.monacoContainer_V75Gq .JSXElement.JSXAttributeValue {
  color: #ce9178 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXExpression {
  color: #dcdcaa !important;
}

.monacoContainer_V75Gq .JSXElement.JSXClosingElement {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXSelfClosingElement {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXFragment {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXOpeningElement {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXClosingFragment {
  color: #569cd6 !important;
}

.monacoContainer_V75Gq .JSXElement.JSXOpeningFragment {
  color: #569cd6 !important;
}

/* Estilos para el modo expandido */
.expanded___5gB .monacoContainer_V75Gq {
  height: calc(100vh - 120px);
}

/* Responsive */
@media (max-width: 768px) {
  .monacoContainer_V75Gq {
    font-size: 12px;
  }
  
  .monacoContainer_V75Gq .monaco-editor {
    font-size: 12px !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/MonacoEditor.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyNG;;AAEH,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".monacoContainer {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  overflow: hidden;\n}\n\n/* .monacoContainer :global(.monaco-editor) {\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .overflow-guard) {\n  border-radius: 0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .margin) {\n  background-color: #252526 !important;\n}\n\n.monacoContainer :global(.monaco-editor .monaco-editor-background) {\n  background-color: #1e1e1e !important;\n}\n\n.monacoContainer :global(.monaco-editor .line-numbers) {\n  color: #858585 !important;\n}\n\n.monacoContainer :global(.monaco-editor .current-line) {\n  background-color: #2a2d2e !important;\n  border: none !important;\n}\n\n.monacoContainer :global(.monaco-editor .selection) {\n  background-color: #264f78 !important;\n}\n\n.monacoContainer :global(.monaco-editor .inactive-selection) {\n  background-color: #3a3d41 !important;\n}\n\n.monacoContainer :global(.monaco-editor .cursor) {\n  background-color: #aeafad !important;\n}\n\n.monacoContainer :global(.monaco-editor .whitespace) {\n  color: #3b3b3b !important;\n}\n\n.monacoContainer :global(.monaco-editor .indent-guide) {\n  background-color: #404040 !important;\n}\n\n.monacoContainer :global(.monaco-editor .indent-guide.active) {\n  background-color: #707070 !important;\n}\n\n.monacoContainer :global(.monaco-editor .scrollbar) {\n  background-color: #2d2d30 !important;\n}\n\n.monacoContainer :global(.monaco-editor .scrollbar .slider) {\n  background-color: #424242 !important;\n}\n\n.monacoContainer :global(.monaco-editor .scrollbar .slider:hover) {\n  background-color: #4f4f4f !important;\n}\n\n.monacoContainer :global(.monaco-editor .scrollbar .slider.active) {\n  background-color: #5a5a5a !important;\n}\n\n\n.monacoContainer :global(.monaco-editor .token.keyword) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.string) {\n  color: #ce9178 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.comment) {\n  color: #6a9955 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.number) {\n  color: #b5cea8 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.regexp) {\n  color: #d16969 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.type) {\n  color: #4ec9b0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.class) {\n  color: #4ec9b0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.interface) {\n  color: #4ec9b0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.enum) {\n  color: #4ec9b0 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.function) {\n  color: #dcdcaa !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.variable) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.constant) {\n  color: #4fc1ff !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.parameter) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.property) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.operator) {\n  color: #d4d4d4 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.delimiter) {\n  color: #d4d4d4 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.tag) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.attribute.name) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.attribute.value) {\n  color: #ce9178 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.meta) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.meta.tag) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag) {\n  color: #808080 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag.begin) {\n  color: #808080 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.punctuation.definition.tag.end) {\n  color: #808080 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.entity.name.tag) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.entity.other.attribute-name) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.support.type.property-name) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.variable.language) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.variable.other) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.variable.other.property) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.constant.language) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.constant.numeric) {\n  color: #b5cea8 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.constant.character) {\n  color: #ce9178 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.constant.other) {\n  color: #4fc1ff !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.invalid) {\n  color: #f44747 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.invalid.deprecated) {\n  color: #f44747 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.invalid.illegal) {\n  color: #f44747 !important;\n}\n\n.monacoContainer :global(.monaco-editor .token.invalid.unexpected) {\n  color: #f44747 !important;\n} */\n\n/* Estilos para el resaltado JSX/TSX */\n.monacoContainer :global(.JSXElement.JSXText.tastyPizza) {\n  color: #d4d4d4 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXIdentifier) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXAttribute) {\n  color: #9cdcfe !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXAttributeValue) {\n  color: #ce9178 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXExpression) {\n  color: #dcdcaa !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXClosingElement) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXSelfClosingElement) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXFragment) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXOpeningElement) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXClosingFragment) {\n  color: #569cd6 !important;\n}\n\n.monacoContainer :global(.JSXElement.JSXOpeningFragment) {\n  color: #569cd6 !important;\n}\n\n/* Estilos para el modo expandido */\n.expanded .monacoContainer {\n  height: calc(100vh - 120px);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .monacoContainer {\n    font-size: 12px;\n  }\n  \n  .monacoContainer :global(.monaco-editor) {\n    font-size: 12px !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monacoContainer": `monacoContainer_V75Gq`,
	"expanded": `expanded___5gB`
};
export default ___CSS_LOADER_EXPORT___;
